import { BodyText } from '@unmind/design-system';
import { Close, NovaVoice } from 'icons';
import { rem } from 'polished';
import styled from 'styled-components';

export const FeedbackBannerContainer = styled.div`
  display: flex;
  gap: ${rem(12)};
  padding: ${rem(12)};
  border-radius: ${rem(8)};
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) =>
    theme.button.primary.disabled.backgroundColor};
  z-index: 1;
`;

export const FeedbackBannerTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  flex-grow: 1;
`;

export const FeedbackBannerText = styled(BodyText)``;

export const FeedbackButtonsContainer = styled.div`
  display: flex;
  gap: ${rem(12)};
  flex-shrink: 0;
`;

export const ShareFeedbackLink = styled.a.attrs({
  className: 'button no-decoration',
})`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0.5rem ${rem(10)};
  border-radius: ${rem(1000)};
  background-color: ${({ theme }) =>
    theme.button.primary.default.backgroundColor};

  &:hover {
    background-color: ${({ theme }) =>
      theme.button.primary.default.hover.backgroundColor};
  }

  &:active {
    background-color: ${({ theme }) =>
      theme.button.primary.default.active.backgroundColor};
  }
`;

export const ShareFeedbackButtonText = styled(BodyText)`
  line-height: 100%;
`;

export const CloseFeedbackButton = styled.button`
  background: none;
  border: none;
  padding: ${rem(8)};
  border-radius: ${rem(20)};
  cursor: pointer;
`;

export const CloseFeedbackButtonIcon = styled(Close)``;

export const NovaVoiceIcon = styled(NovaVoice)`
  flex-shrink: 0;
`;
